import { createOptions } from '../../common/rest/index.tsx';

type DeleteComponent = (
	baseUrl: string,
	componentId: string,
	moveIssuesTo?: string,
) => Promise<Response>;

type ComponentRelatedIssueCount = (baseUrl: string, componentId: string) => Promise<Response>;

const getUrl = (baseUrl: string, componentId: string): string =>
	`${baseUrl}/rest/api/2/component/${componentId}`;

export const deleteComponent: DeleteComponent = async (baseUrl, componentId, moveIssuesTo) => {
	const queryString = moveIssuesTo ? `?moveIssuesTo=${moveIssuesTo}` : '';
	const fullUrl = `${getUrl(baseUrl, componentId)}${queryString}`;
	return fetch(fullUrl, createOptions('DELETE'));
};

export const getComponentRelatedIssueCount: ComponentRelatedIssueCount = async (
	baseUrl,
	componentId,
) => {
	const fullUrl = `${getUrl(baseUrl, componentId)}/relatedIssueCounts`;
	return fetch(fullUrl, createOptions('GET'));
};
